export * from './employeeDemographicReport.component';
export * from './employeeDemographicReport.service';
export * from './employeeDemographicDetail';



// WEBPACK FOOTER //
// ./src/app/EmployeeDemographicsReport/index.ts